<template>
  <header class="header">
    <div class="header__block">
      <h1>モロ見せ案内所</h1>
      <h2>極上の女の子のみ厳選！100%脱ぐ！<span>モロ見せ保証！</span></h2>
    </div>
  </header>
  <section id="marquee">
    <div class="marquee-container">
      <div class="marquee-content">
        <span>【自己紹介】ライブチャット歴14年を誇る管理人が自腹を切って大金を使い、数多くの女の子をチェック。絶対に損をしない、超極上の女の子だけを表示しています。アソコのモロ出し100％保証！ぜひお試しあれ！</span>
        <span>【裏技】女の子によっては、オフパコOKなケースもあります。管理人は今までで、2人とオフパコ成功例があります。いきなり頼んでも無理なので、ガツガツせず、打ち解けてからお願いするのがポイント。</span>
        <span>【ヒント】ライブビュワーで会話が出来るのは、無料アカウントを持っている会員だけとなるので、ご注意を！</span>
      </div>
    </div>
  </section>
</template>

<script>
</script>

<style scoped lang="scss">
.header {
  padding: 1em 0 1em .5em;
  background: #292f33;

  img {
    height: 11rem;
    display: block;
    margin-left: -5rem;
  }

  @media (max-width: 768px) {
    column-gap: 0;

    img {
      margin-left: 0;
      height: 8rem;
    }
  }

  &__block {
    max-width: 560px;
    margin: 0 auto;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    background: url(https://livechat-ero.com/freechat/img/woman_pink.png) no-repeat;
    background-size: contain;

    h1 {
      font-size: 3em;
      font-weight: 800;
      line-height: 1.1;
    }

    h2 {
      font-size: 1.2em;
      font-weight: 400;

      span {
        display: inline-block;
      }
    }

    @media (max-width: 768px) {
      max-width: 450px;

      h1 {
        font-size: 2em;
      }

      h2 {
        font-size: 1em;
        text-align: center;
      }
    }

    @media (max-width: 500px) {
      max-width: 350px;

      h2 {
        font-size: 12px;
      }
    }
  }
}

.marquee-container {
  width: 100%;
  padding: 1rem 0;
  margin: 0 auto;
  overflow: hidden;
  background-color: #f8edf9;
  color: #e525a5;
  font-size: 16px;
}

.marquee-content {
  display: inline-block;
  white-space: nowrap;
  padding-left: 100%;
  animation: marquee 40s linear infinite;

  span {
    display: inline-block;
    padding-right: 6em; // 段落間の間隔を追加
  }
}

@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
</style>